import { DextNumberInputWUT } from '@wix/form-fields/viewer-wut';

export default DextNumberInputWUT;
